import {
  forwardRef,
  PropsWithChildren,
  RefAttributes,
  ForwardRefExoticComponent,
  MouseEventHandler,
} from 'react';
import cns from 'classnames';

import styles from './Button.module.scss';

interface IButtonProps extends RefAttributes<HTMLButtonElement> {
  className?: string;
  disabled?: boolean;
  type?: 'primary' | 'outline';
  htmlType?: 'button' | 'submit' | 'reset';
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const Button: ForwardRefExoticComponent<PropsWithChildren<IButtonProps>> = forwardRef(
  (
    {
      className,
      type = 'primary',
      htmlType = 'button',
      children,
      onClick,
      ...rest
    },
    ref
  ) => {
   ;

    return (
      <button
        onClick={(e) => {
          
          if (onClick) {
            
            onClick(e);
          }
        }}
        ref={ref}
        className={cns(styles.button, styles[type], className)}
        type={htmlType}
        {...rest}
      >
        <div className={styles.children}>{children}</div>
      </button>
    );
  }
);

export default Button;
